import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 大物流同步接口记录 lhx
export const failRecordList = (data) => {
    return request({
        url: apiCrmHost + '/anomaly/record/page',
        method: 'post',
        data
    });
};
